import React from 'react';
import DebugBoxLarge from './DebugBoxLarge';
import DebugState from './DebugState';

interface DebugSummaryProps {
    pageName: string,
    componentName: string,
    eligibility: any,
    showErrors: any,
    errors: any
}

/** Place within an eligibility page component. **/
const DebugEligibilitySummary = (props: DebugSummaryProps) => <DebugBoxLarge>
    <h2>Debug Information</h2>
    <p>
        This is the {props.pageName} page.<br />
        This is defined in the <strong>gaas-react-component-library</strong> component <strong>
            {props.componentName}</strong>.
    </p>
    <DebugState
        title='The mapped model variables are'
        state={ props.eligibility }
        withinDebugBox
    />
    <DebugState
        title={ `The validation errors ${props.showErrors ? 'are' : 'will be'}` }
        state={ props.errors }
        withinDebugBox
    />
</DebugBoxLarge>;

export default DebugEligibilitySummary;
